import React, { useEffect } from "react";
import EmployeeLocation from "../../components/admin/EmployeeLocation";

const EmployeeLocationPage = () => {

    useEffect(() => {
        document.body.id = "EmployeeLocation-007";
      }, []);

  return (
    <div>
    <EmployeeLocation />
    </div>
  );
};

export default EmployeeLocationPage;
